import Vue from 'vue';
import VueRouter from 'vue-router';
import CobraQuoteSetup from '@/components/CobraQuoteSetup.vue';
import ServiceQuoteForm from '@/components/ServiceQuoteForm.vue';
import BeginIntegration from '@/components/BeginIntegration.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/CobraQuoteSetup' // Redirect the root path to CobraQuoteSetup
  },
  {
    path: '/CobraQuoteSetup',
    name: 'CobraQuoteSetup',
    component: CobraQuoteSetup
  },
  {
    path: '/ServiceQuoteForm',
    name: 'ServiceQuoteForm',
    component: ServiceQuoteForm
  },
  {
    path: '/BeginIntegration',
    name: 'BeginIntegration',
    component: BeginIntegration
  },
];


const router = new VueRouter({
  routes
});

export default router;

